// @ts-nocheck
import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
/* import InfosBoxComponent, {
    InfosBoxSize,
    infosBoxSizeOptions,
    InfosBoxType,
    infosBoxTypeOptions,
} from "@store/Library/Components/Toolkit/InfosBox"; Foundation */
import { getDataOptionsFieldDefinition } from "@toolkit/Framework/Common/Utilities/dataOptions";
import parse from "html-react-parser";
import React, { FC } from "react";

/* Foundation Custom Code - Start */
import InfosBoxComponent, {
    InfosBoxSize,
    infosBoxSizeOptions,
    InfosBoxType,
    infosBoxTypeOptions,
} from "@store/Library/Components/Toolkit/InfosBox";
/* Foundation Custom Code - End */

const enum fields {
    // Foundation Custom Code - Removed htmlContent
    showIcon = "showIcon",
    size = "size",
    type = "type",
    content = "content", // Foundation
}

interface Props extends WidgetProps {
    fields: {
        // Foundation Custom Code - Removed htmlContent
        [fields.showIcon]: boolean;
        [fields.size]: InfosBoxSize;
        [fields.type]: InfosBoxType;
        /* Foundation Custom Code - Start */
        [fields.content]:
            | JSX.Element
            | string
            | string[]
            | React.DetailedReactHTMLElement<{}, HTMLElement>
            | Array<React.DetailedReactHTMLElement<{}, HTMLElement>>;
        /* Foundation Custom Code - End */
    };
}

/* Foundation Custom Code - Start */
const InfosBox: FC<Props> = ({ fields: { content, showIcon = true, size = "medium", type = "default" } }) => {
    if (!content) {
        return null;
    }

    return (
        <InfosBoxComponent type={type} showIcon={showIcon} size={size}>
            {typeof content === "string" ? parse(content, parserOptions) : content}
        </InfosBoxComponent>
    );
};
/* Foundation Custom Code - End */

const widgetModule: WidgetModule = {
    component: InfosBox,
    definition: {
        displayName: "Infos Box",
        group: "Basic",
        icon: "circle-i",
        fieldDefinitions: [
            {
                ...getDataOptionsFieldDefinition(infosBoxTypeOptions),
                name: fields.type,
                displayName: "Type",
                fieldType: "Contextual",
                hideEmptyOption: true,
            },
            {
                ...getDataOptionsFieldDefinition(infosBoxSizeOptions),
                name: fields.size,
                displayName: "Size",
                fieldType: "Contextual",
                hideEmptyOption: true,
            },
            {
                name: fields.showIcon,
                displayName: "Show Icon",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "Contextual",
            },
            {
                name: fields.content, // Foundation Custom Code
                displayName: "Content",
                editorTemplate: "RichTextField",
                defaultValue: "",
                fieldType: "Contextual",
            },
        ],
    },
};

export default widgetModule;
